// Vuex 4 bootstrap (KAT-943 Phase 2b): `createStore` replaces `Vue.use(Vuex); new Vuex.Store()`.
import { createStore } from 'vuex'
import book from './modules/book'
import auth from './modules/auth'
import ui from './modules/ui'
import userPageFavorite from './modules/userPageFavorite'
import draw from './modules/draw'
import audio from './modules/audio'
import note from './modules/userPageNote'
import url from './modules/userPageUrl'
import privacy from './modules/privacy'
import userInfo from './modules/userInfo'
// Replaces `vuex-router-sync` (no stable Vue 3 release) — see the module's own comment.
import route from './modules/route'

// import.meta.env.DEV replaces process.env.NODE_ENV !== 'production' (Vite convention —
// process.env.NODE_ENV isn't defined in client-side code the way webpack's DefinePlugin used
// to provide it).
const debug = import.meta.env.DEV

export default createStore({
  modules: {
    book,
    auth,
    ui,
    userPageFavorite,
    draw,
    audio,
    note,
    url,
    privacy,
    userInfo,
    route
  },
  strict: debug
})
